@if (dateOnly) {
  <div class="row">
    <div [class]="{ 'col-md-12': dateOnly, 'col-md-7': !dateOnly }">
      <mat-form-field class="full-width" appearance="outline">
        <mat-label>{{ 'forms:' + field.label | i18nextCap }}</mat-label>
        <input
          (dateChange)="onDateChange($event)"
          matInput
          [matDatepicker]="picker"
          [name]="field.name"
          [formControl]="$any(formGroup.controls[field.name])"
          [matDatepickerFilter]="
            $any(
              field.fullDate?.matDatepickerFilter
                ? field.fullDate.matDatepickerFilter
                : null
            )
          "
        />
        <mat-datepicker-toggle
          matIconSuffix
          [for]="picker"
        ></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error>
          {{
            formGroup.controls[field.name]?.errors
              ? formGroup.controls[field.name]?.errors?.message
                ? ('error:' + formGroup.controls[field.name].errors.message
                  | i18nextCap)
                : ('validation:youMustSelectADate' | i18nextCap)
              : ('validation:youMustSelectADate' | i18nextCap)
          }}
        </mat-error>
      </mat-form-field>
    </div>
  </div>
}
@if (!dateOnly) {
  <fo-date-time-input
    mainLabel="forms:{{ field.label }}"
    [timeLabel]="getLabelName()"
    [dateFilter]="$any(field.fullDate?.matDatepickerFilter)"
    [formControl]="$any(formGroup.controls[field.name])"
    [timeAlwaysEnabled]="!!field.fullDate?.hourNeverDisabled"
    [minTimeMinutes]="field.fullDate?.minMinute ?? 0"
    [maxTimeMinutes]="field.fullDate?.maxMinute ?? 1440"
  >
  </fo-date-time-input>
}
